import React, { Fragment, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { find, propEq } from 'ramda';

import { Button, BUTTON_SIZE, Select, SelectArrow, SelectOption } from '@components/form';
import { GiftCertificateModal } from '@components/PDP/giftCertificateModal';
import { Variant } from '@definitions/giftCertificate.types';

import { SelectWrapper } from './giftCertificateActions.styles';

export interface GiftCertificateActionsProps {
  onThemeChange: (theme?: Variant) => void;
  theme?: Variant;
  variants: Variant[];
}

export const GiftCertificateActions = ({ onThemeChange, theme, variants }: GiftCertificateActionsProps) => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState(false);
  const themePlaceholder = intl.formatMessage({ id: 'giftCertificateSidebar.choose', defaultMessage: 'Choose design' });

  const onSelectTheme = (value: string) => {
    const theme = find(propEq('id', value), variants);
    onThemeChange(theme);
  };

  return (
    <Fragment>
      <SelectWrapper>
        <Select onChange={(e) => onSelectTheme(e.target.value)} defaultValue="default">
          <SelectOption value="default" disabled>
            {themePlaceholder}
          </SelectOption>
          {variants.map(({ value, id }, index) => (
            <SelectOption key={index} value={id}>
              {value.name}
            </SelectOption>
          ))}
        </Select>
        <SelectArrow />
      </SelectWrapper>
      <Button fullWidth size={BUTTON_SIZE.L} onClick={() => setShowModal(true)} disabled={!theme}>
        <FormattedMessage id="giftCertificateSidebar.continue" defaultMessage="CONTINUE" />
      </Button>
      <GiftCertificateModal isOpen={showModal} setOpen={setShowModal} theme={theme} />
    </Fragment>
  );
};
